import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell, { authField, authBtn } from "./AuthShell";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to track your shipments and manage requests."
      footer={
        <>
          New here?{" "}
          <Link to="/register" className="text-gold link-underline" data-testid="to-register">
            Create an account
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4">
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={authField} data-testid="login-email" />
        <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={authField} data-testid="login-password" />
        {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className={authBtn} data-testid="login-submit">
          {loading && <Loader2 size={18} className="animate-spin" />}
          {loading ? "SIGNING IN..." : "SIGN IN"}
        </button>
      </form>
      <div className="mt-6 text-xs text-cream/40 border-t border-gold/10 pt-4">
        Demo client — client@demo.com / demo123
      </div>
    </AuthShell>
  );
}
